export default __webpack_public_path__ + "static/13-3cc7b0337ecb0833e2b5e35dcbabc7e7.jpg";